<template>
	<div>{{ segundos | secondsFormated }}</div>
</template>

<script>
import moment from "moment";
export default {
	props: {
		milisegundos: {
			type: Number,
			default: 0,
		},
		utc: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			segundos: 0,
			timer: null,
		};
	},
	mounted() {
		this.startTimer();
	},
	destroyed() {
		this.stopTimer();
	},
	methods: {
		startTimer() {
			if(this.utc){
				const dateTime = moment(this.milisegundos);
				this.segundos = Math.trunc(
					(moment().valueOf() - dateTime.valueOf()) / 1000
				);
			}
			else {
				this.segundos = Math.trunc(this.milisegundos / 1000);
			}

			if (this.timer != null) return;

			this.timer = setInterval(() => {
				this.segundos++;
			}, 1000);
		},
		stopTimer() {
			if (this.timer == null) return;
			clearInterval(this.timer);
			this.timer = null;
		},
	},
	filters: {
		secondsFormated(seconds) {
			// Convertimos el número total de segundos en horas, minutos y segundos
			let hours = Math.floor(seconds / 3600);
			let minutes = Math.floor((seconds % 3600) / 60);
			let sec = seconds % 60;

			// Formateamos horas, minutos y segundos para asegurarnos de que tengan dos dígitos
			hours = hours.toString().padStart(2, '0');
			minutes = minutes.toString().padStart(2, '0');
			sec = sec.toString().padStart(2, '0');

			// Devolvemos el string con el formato HH:mm:ss
			return `${hours}:${minutes}:${sec}`;
		},
	},
};
</script>